<!-- Prevent prettier to remove parentheses from v-model type cast -->
<!-- prettier-ignore -->
<template>
  <div>
    <RevDrawer
      :close-button-label="i18n(modalTranslations.close)"
      :name="MODAL_NAMES.REFURBISHER_WISHLIST_FILTERS"
      :title="i18n(translations.filter)"
    >
      <template #body>
        <div class="flex h-full flex-col justify-between">
          <form @submit.prevent="handleFilters">
            <div class="flex flex-col gap-16">
              <RevInputText
                id="model"
                v-model="filterValues.model"
                :label="i18n(translations.modelLabel)"
                name="model"
              />
              <RevInputText
                id="brand"
                v-model="filterValues.brand"
                :label="i18n(translations.brandLabel)"
                name="brand"
              />
              <RevInputSelect
                id="grades"
                v-model="(filterValues.grades as Value)"
                :label="i18n(translations.gradeLabel)"
                name="grades"
                :options="gradesOptions"
              />
              <RevInputSelect
                id="online"
                v-model="(filterValues.state as Value)"
                :label="i18n(translations.publicationStateLabel)"
                name="online"
                :options="stateOptions"
              />
              <RevInputText
                id="productId"
                v-model="filterValues.productId"
                :label="i18n(translations.prodcutIdLabel)"
                name="productId"
              />
              <RevInputText
                id="sku"
                v-model="filterValues.sku"
                :label="i18n(translations.skuLabel)"
                name="sku"
              />
              <RevInputText
                id="releaseYear"
                v-model="filterValues.releaseYear"
                :label="i18n(translations.releaseYearLabel)"
                name="releaseYear"
                type="number"
              />
            </div>
          </form>
          <div class="mt-auto flex flex-col gap-12">
            <RevButton
              full-width="always"
              variant="primary"
              @click="handleFilters"
            >
              {{ i18n(translations.applyFilters) }}
            </RevButton>

            <RevButton
              full-width="always"
              :loading="isResetting"
              variant="secondary"
              @click="handleResetFilters"
            >
              {{ i18n(translations.reset) }}
            </RevButton>
          </div>
        </div>
      </template>
    </RevDrawer>

    <RevStickyBar>
      <RevButton
        full-width="always"
        variant="primary"
        @click="handleFilterOpenModal"
      >
        {{ i18n(translations.filter) }}
      </RevButton>
    </RevStickyBar>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import modalTranslations from '@backmarket/nuxt-layer-buyback/utils/Modal.translations'
import MODAL_NAMES from '@backmarket/nuxt-layer-buyback/utils/modals'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevDrawer } from '@ds/components/Drawer'
import { RevInputSelect, type Value } from '@ds/components/InputSelect'
import { RevInputText } from '@ds/components/InputText'
import { closeModal, openModal } from '@ds/components/ModalBase'
import { RevStickyBar } from '@ds/components/StickyBar'

import { FILTERS_BUTTONS } from '../Filters.constants'
import translations from '../Filters.translations'
import type {
  FilterEventPayload,
  FilterOption,
  WishlistFilters,
} from '../Filters.types'

const props = withDefaults(
  defineProps<{
    initialValues: WishlistFilters
    gradesOptions: Array<FilterOption>
    stateOptions: Array<FilterOption>
    loadingButton?: string
  }>(),
  {
    loadingButton: '',
  },
)

const emit = defineEmits<{
  (e: 'filter', payload: FilterEventPayload): void
}>()

const i18n = useI18n()

const filterValues = ref({ ...props.initialValues })

const isResetting = computed(
  () => props.loadingButton === FILTERS_BUTTONS.RESET,
)

function handleFilterOpenModal() {
  openModal(MODAL_NAMES.REFURBISHER_WISHLIST_FILTERS)
}
function handleFilters() {
  emit('filter', {
    filters: { ...filterValues.value },
    actionButton: FILTERS_BUTTONS.FILTER,
  })
  closeModal(MODAL_NAMES.REFURBISHER_WISHLIST_FILTERS)
}
function handleResetFilters() {
  filterValues.value = { ...props.initialValues }
  emit('filter', {
    filters: { ...filterValues.value },
    actionButton: FILTERS_BUTTONS.RESET,
  })
}
</script>
